import { render, staticRenderFns } from "./masonryAuth.vue?vue&type=template&id=920cbaf2&"
import script from "./masonryAuth.vue?vue&type=script&lang=js&"
export * from "./masonryAuth.vue?vue&type=script&lang=js&"
import style0 from "./masonryAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports